export const CONTACT_LISTS_MENU_CONDITION = {
  NON_EMPTY: 'non-empty',
  EMPTY: 'empty',
  STATIC: 'static',
  DYNAMIC: 'dynamic',
};
